"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ButtonDoCalc = /** @class */ (function (_super) {
    __extends(ButtonDoCalc, _super);
    function ButtonDoCalc(props) {
        return _super.call(this, props) || this;
    }
    ButtonDoCalc.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    ButtonDoCalc.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { disabled: this.props.disabled, icon: "calculator", ghost: true, type: "danger", style: { margin: "2px", marginBottom: "7px" }, onClick: this.buttonClick.bind(this) })));
    };
    return ButtonDoCalc;
}(React.Component));
exports.default = ButtonDoCalc;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/buttons/ButtonDoCalc.tsx
// module id = 2004
// module chunks = 0